module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/bg-b3dbd251b0a7c431da097a09db018023.jpg";